export { default } from './CatalogueSearchBar';



// WEBPACK FOOTER //
// ./app/components/search/CatalogueSearchBar/index.js